import { Button, StatusCard } from "@neonumy/neonumy-ui";
import { Content } from "antd/lib/layout/layout";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Page404(): React.ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Content>
      <StatusCard
        title={t("Page Not Found")}
        message={t("The page you are looking for does not exist or has been moved")}
      >
        <Button type="primary" onClick={() => navigate("/")}>
          {t("Go to Home")}
        </Button>
      </StatusCard>
    </Content>
  );
}

export default Page404;
